import React from 'react';
import { Link } from 'react-router-dom';

const styles = {
  page: {
    minHeight: '100vh',
    background: '#18181B',
    color: '#B5B5BC',
    padding: '80px 6vw 100px',
    maxWidth: 760,
    margin: '0 auto',
  },
  back: {
    color: '#C9A66B',
    textDecoration: 'none',
    fontSize: 13,
    display: 'inline-block',
    marginBottom: 32,
  },
  title: {
    fontFamily: "'Unbounded', sans-serif",
    fontWeight: 900,
    fontSize: 'clamp(28px, 5vw, 40px)',
    color: '#F5F3ED',
    marginBottom: 8,
  },
  updated: {
    fontSize: 13,
    color: '#6E6E76',
    marginBottom: 40,
  },
  h2: {
    color: '#C9A66B',
    fontSize: 18,
    marginTop: 36,
    marginBottom: 12,
  },
  p: {
    fontSize: 15,
    lineHeight: 1.75,
    marginBottom: 12,
  },
  ul: {
    fontSize: 15,
    lineHeight: 1.75,
    paddingLeft: 20,
    marginBottom: 12,
  },
  link: {
    color: '#C9A66B',
    textDecoration: 'none',
  },
};

export default function PrivacyPolicy() {
  return (
    <div style={styles.page}>
      <Link to="/" style={styles.back}>← Beranda</Link>
      <h1 style={styles.title}>Kebijakan Privasi</h1>
      <p style={styles.updated}>Terakhir diperbarui: Juli 2026</p>

      <p style={styles.p}>
        Saskara Record ("kami") menghargai privasi pengguna situs saskararecord.com
        ("Situs"). Kebijakan ini menjelaskan data apa yang kami kumpulkan, bagaimana kami
        menggunakannya, dan hak kamu sebagai pengguna, sejalan dengan prinsip perlindungan
        data pribadi yang berlaku di Indonesia.
      </p>

      <h2 style={styles.h2}>1. Data yang Kami Kumpulkan</h2>
      <ul style={styles.ul}>
        <li>Data akun: nama, alamat email, nomor telepon, kata sandi (tersimpan terenkripsi)</li>
        <li>Data profil: foto profil, alamat pengiriman (untuk pemesanan merchandise)</li>
        <li>Data transaksi: riwayat pesanan, status pembayaran</li>
        <li>Data interaksi: artis yang kamu follow, lagu/konten yang kamu sukai</li>
        <li>Data teknis dasar: alamat IP dan informasi perangkat untuk keperluan keamanan</li>
      </ul>

      <h2 style={styles.h2}>2. Bagaimana Kami Menggunakan Data</h2>
      <ul style={styles.ul}>
        <li>Memproses pendaftaran akun dan autentikasi login</li>
        <li>Memproses pesanan merchandise dan tiket event</li>
        <li>Mengirim email notifikasi yang kamu setujui (misalnya update dari artis yang kamu follow, promo, atau konfirmasi pesanan)</li>
        <li>Meningkatkan kualitas layanan dan keamanan Situs</li>
      </ul>

      <h2 style={styles.h2}>3. Berbagi Data dengan Pihak Ketiga</h2>
      <p style={styles.p}>
        Kami tidak menjual data pribadi kamu kepada pihak manapun. Data hanya dibagikan ke
        penyedia layanan pihak ketiga yang diperlukan untuk operasional Situs, misalnya
        penyedia gerbang pembayaran untuk memproses transaksi, dan penyedia layanan email
        untuk mengirim notifikasi resmi dari Situs.
      </p>

      <h2 style={styles.h2}>4. Keamanan Data</h2>
      <p style={styles.p}>
        Kata sandi kamu disimpan dalam bentuk terenkripsi (hashed) dan tidak dapat dibaca
        langsung oleh siapa pun, termasuk tim kami. Kami menerapkan langkah-langkah teknis
        yang wajar untuk melindungi data kamu dari akses yang tidak sah.
      </p>

      <h2 style={styles.h2}>5. Hak Kamu</h2>
      <ul style={styles.ul}>
        <li>Mengakses dan memperbarui data profil kamu kapan saja melalui halaman akun</li>
        <li>Meminta penghapusan akun dan data terkait dengan menghubungi kami</li>
        <li>Berhenti berlangganan email notifikasi (opsi tersedia di setiap email yang kami kirim, atau hubungi kami langsung)</li>
      </ul>

      <h2 style={styles.h2}>6. Perubahan Kebijakan</h2>
      <p style={styles.p}>
        Kami dapat memperbarui kebijakan ini dari waktu ke waktu. Perubahan signifikan akan
        diinformasikan melalui Situs atau email.
      </p>

      <h2 style={styles.h2}>7. Hubungi Kami</h2>
      <p style={styles.p}>
        Jika ada pertanyaan seputar kebijakan privasi ini, silakan hubungi kami di{' '}
        <a href="mailto:info@saskararecord.com" style={styles.link}>info@saskararecord.com</a>
        {' '}atau kunjungi halaman <Link to="/contact" style={styles.link}>Kontak</Link> kami.
      </p>
    </div>
  );
}
